<div id="mantenimiento" fxLayout="column">
    <div id="bgImg"></div>
    <div id="mantenimiento-form-wrapper" fxLayout="column" fxLayoutAlign="center center">

        <div id="mantenimiento-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">

            <div class="logo">
                <img src="assets/logo_GO2.jpg">
            </div>

            <div class="title">{{'LOGIN.MODALES.AVISO1.TITULO' | translate}}</div>

            <div class="subtitle" [innerHTML]="textoAviso">
                <!-- <p>Estimado usuario:</p>
                <p>Se le comunica que, con el objetivo de poder brindar un mejor servicio, se realizará una actualización de la plataforma Cultural GO para optimizar su funcionamiento.</p>
                <p>La actualización se llevará a cabo el día <strong>miercoles 1 de abril, a partir de las 20:00, hasta las 08:00 del día jueves 2 de abril</strong>. Durante ese periodo la plataforma permanecerá inactiva. Sin embargo, las encuestas vigentes seguirán activas. </p>
                <p>Agradecemos su comprensión.</p> -->
            </div>

        </div>

    </div>

</div>
